export class StepProgressView {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "percentX100",
            "baseName": "percentX100",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "etaSeconds",
            "baseName": "etaSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rate",
            "baseName": "rate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rateUnit",
            "baseName": "rateUnit",
            "type": "StepProgressUnit",
            "format": ""
        },
        {
            "name": "progressAt",
            "baseName": "progressAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "metrics",
            "baseName": "metrics",
            "type": "Array<StepProgressMetric>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StepProgressView.attributeTypeMap;
    }
    constructor() {
    }
}
